<template>
  <Layout>
    <template v-slot:title>Cambiar Contraseña</template>
    <div class="mt-20 mx-4">
      <BaseAlert v-if="showAlert" class="alert-success mb-8">
        La contraseña ha sido cambiada correctamente
      </BaseAlert>
      <form class="max-w-sm mx-auto" novalidate @submit.prevent="sendData">
        <BaseInputText
          ref="oldPassword"
          type="password"
          label="Contraseña Antigua"
          name="old_password"
          class="mb-4"
          :value="oldPassword"
          :v="$v.oldPassword"
          @input="updateOldPassword"
          @blur="$v.oldPassword.$touch()"
        />

        <BaseInputText
          type="password"
          label="Contraseña Nueva"
          name="password"
          class="mb-4"
          :value="password"
          :v="$v.password"
          @input="updatePassword"
          @blur="$v.password.$touch()"
        />

        <BaseInputText
          type="password"
          label="Repite Contraseña"
          name="repeat_password"
          class="mb-4"
          :value="repeatPassword"
          :v="$v.repeatPassword"
          @input="updateRepeatPassword"
          @blur="$v.repeatPassword.$touch()"
        />

        <LoadingButton class="mt-8" :loading="sendingData">
          Enviar
        </LoadingButton>
      </form>
    </div>
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import updateFieldMixin from '@/mixins/updateFieldMixin'
import Layout from '@/layouts/MainLayout'
import LoadingButton from '@/components/LoadingButton'

export default {
  components: { Layout, LoadingButton },
  mixins: [validationMixin, updateFieldMixin],

  computed: {
    ...mapState('forms', ['sendingData']),
    ...mapState('auth', [
      'passwordMinLength',
      'oldPassword',
      'password',
      'repeatPassword',
      'showAlert',
    ]),
  },

  mounted() {
    this.$store.commit('auth/resetChangePassword')
    this.$store.commit('auth/showAlert', false)
    this.$refs.oldPassword.$el.querySelector('input').focus()
  },

  methods: {
    updateOldPassword(e) {
      this.updateField(e, 'auth/updateOldPassword', 'old_password')
    },

    updatePassword(e) {
      this.updateField(e, 'auth/updatePassword', 'password')
    },

    updateRepeatPassword(e) {
      this.updateField(e, 'auth/updateRepeatPassword', 'repeat_password')
    },

    sendData() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const payload = {
          old_password: this.oldPassword,
          password: this.password,
          repeat_password: this.repeatPassword,
        }
        this.$store.dispatch('auth/changePassword', payload)
        this.$v.$reset()
      }
    },
  },

  validations() {
    const passLength = this.passwordMinLength
    return {
      oldPassword: { required },
      password: { required, minLength: minLength(passLength) },
      repeatPassword: { required, sameAsPassword: sameAs('password') },
    }
  },
}
</script>
